import type { AccessPair } from '@/shared/lib'

/*
 * Пары прав сборки ПК — зеркало `@ActingAs` бэка (`src/pc-build/pc-build.controller.ts`,
 * `docs/plan/process-coverage.md` §6). Меняется у бэка — меняется здесь.
 */

/**
 * Список сборок `GET /v1/pc-build`: клиент смотрит свои (`pc-build.view`), менеджер — глазами
 * клиента (`manager.orders.view`, модификатор `client`/`account`). Это и пара страницы `/pc-build`.
 */
export const PC_BUILD_ACCESS: AccessPair = {
  own: 'pc-build.view',
  onBehalf: 'manager.orders.view',
  accepts: ['account'],
}

/**
 * Дерево и грид набора (`GET /v1/pc-build/tree`, `/products`): то же чтение сборки у клиента, у
 * менеджера — вид каталога глазами клиента (`catalog.view-as-client`). Принимает те же параметры
 * контекста, что каталог: учётную запись, юрлицо, вкладку цен и корзину менеджера.
 */
export const PC_BUILD_CATALOG_ACCESS: AccessPair = {
  own: 'pc-build.view',
  onBehalf: 'catalog.view-as-client',
  accepts: ['account', 'unp', 'settlement', 'cart'],
}

/**
 * Собрать из корзины `POST /v1/pc-build/from-cart` — своё право `pc-build.order`, не чтение.
 * Модификатора ручка не принимает (у менеджера сборка за клиента идёт через корзину менеджера).
 */
export const PC_BUILD_ORDER_ACCESS: AccessPair = { own: 'pc-build.order' }

/**
 * Правка и удаление черновика (`PATCH`/`DELETE /v1/pc-build/lines`): клиент — `pc-build.order`,
 * менеджер за клиента — `manager.order.edit`.
 */
export const PC_BUILD_EDIT_ACCESS: AccessPair = {
  own: 'pc-build.order',
  onBehalf: 'manager.order.edit',
  accepts: ['account'],
}

/**
 * Подтвердить и заказать сборку (`POST /v1/pc-build/confirm`, `/order`): клиент — `pc-build.order`,
 * менеджер за клиента — `manager.order.create`.
 */
export const PC_BUILD_SUBMIT_ACCESS: AccessPair = {
  own: 'pc-build.order',
  onBehalf: 'manager.order.create',
  accepts: ['account'],
}

/**
 * Списать позиции `POST /v1/pc-build/write-off` — только клиент (`invoice.write-off`). Ручка
 * модификатора не принимает: у менеджера с `?client=` действие скрыто (пары `onBehalf` нет), а бэк
 * ответил бы `403`.
 */
export const PC_BUILD_WRITE_OFF_ACCESS: AccessPair = { own: 'invoice.write-off' }
